import {timeoutHideToast, showToast} from "./blade-toast.js";
const copyLinks = document.getElementsByClassName("copy-link");

const copyLinkToClipboard = (link) => {
  navigator.clipboard.writeText(link).then(
    function () {
      showToast("Success", "The link was copied to clipboard!");
      timeoutHideToast(3000);
    },
    function (err) {
      showToast("Failed to copy link to clipboard!", err);
    }
  );
};

for (let i = 0; i < copyLinks.length; i++) {
  copyLinks[i].addEventListener("click", function (event) {
    const link = event.target.getAttribute("data-url");
    copyLinkToClipboard(link);
  });
}
